import type { LanguageCode } from "@/config/i18n";
import { isValidLanguage } from "@/config/i18n";
import { LANGUAGE_COOKIE_NAME } from "@/lib/i18n/negotiate";

/**
 * Read the user's explicit language choice (client-side only).
 */
export function getLanguageFromCookie(): LanguageCode | null {
  if (typeof document === "undefined") return null;

  const value = document.cookie
    .split("; ")
    .find((c) => c.startsWith(`${LANGUAGE_COOKIE_NAME}=`))
    ?.split("=")[1];

  return value && isValidLanguage(value) ? value : null;
}

/**
 * Remember the user's explicit language choice for one year. This is a
 * strictly-necessary preference cookie (set only on user action).
 */
export function setLanguageCookie(language: LanguageCode): void {
  if (typeof document === "undefined") return;

  const maxAge = 60 * 60 * 24 * 365;

  document.cookie = `${LANGUAGE_COOKIE_NAME}=${language}; path=/; max-age=${maxAge}; SameSite=Lax`;
}
